// 主题注册中心
import defaultConfig from './default/theme.config.js'
import zeroCarbonConfig from './zero-carbon/theme.config.js'
import chemVideoConfig from './chem-video/theme.config.js'
import kpzpConfig from './kpzp/theme.config.js'

const themeRegistry = {
  'default': defaultConfig,
  'zero-carbon': zeroCarbonConfig,
  'chem-video': chemVideoConfig,
  'kpzp': kpzpConfig
}

export function getAvailableThemes() {
  return Object.values(themeRegistry)
}

export function getThemeConfig(themeCode) {
  return themeRegistry[themeCode] || themeRegistry['default']
}

export default themeRegistry
